import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Stack, Typography, useTheme } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

const GreenSelectButton = ({ rink, active, onToggle }) => {
  const theme = useTheme();
  return (
    <Stack
      alignItems="center"
      justifyContent={'center'}
      style={{
        margin: '5px',
        border: `1px solid ${active ? theme.palette.success.main : theme.palette.error.main}`,
        borderColor: active ? theme.palette.success : theme.palette.error,
        padding: '2px',
        borderRadius: '4px'
      }}>
      <Typography variant="span" color="textPrimary" style={{ marginRight: '8px' }}>
        {rink}
      </Typography>
      <IconButton
        variant="contained"
        color={active ? 'success' : 'error'}
        onClick={() => onToggle(rink)}
        style={{ margin: '5px' }}>
        {active ? <CheckIcon /> : <CloseIcon />}
      </IconButton>
    </Stack>
  );
};

GreenSelectButton.propTypes = {
  rink: PropTypes.number.isRequired,
  active: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired
};

export default GreenSelectButton;
